import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import displayError from '../../utils/ErrorHandler';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';

const SupplierListItems = () => {
  const [items, setItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URI}/api/supplier/getSuppliersItems`, { withCredentials: true })
      .then(response => {
        console.log(response);
        const initialItems = response?.data?.data[0].items?.map(item => ({ ...item, quantity: 0 }));
        setItems(initialItems);
      })
      .catch((err) => {
        const errorMessage = displayError(err, navigate, setUser);
        console.log(errorMessage);
        if (errorMessage) {
          setMessage(errorMessage);
        }
      });
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const getBadgeClass = (purchaseType) => {
    switch (purchaseType) {
      case 'zone':
        return 'bg-blue-500 text-blue-100';
      case 'central':
        return 'bg-teal-600 text-teal-100';
      default:
        return 'bg-blue-500 text-blue-100'; // Default color if purchaseType is not recognized
    }
  };

  const filteredItems = items.filter(item =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.category.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="p-4">
      {message ? (
        <div className="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span className="block sm:inline">{message}</span>
          <span className="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
        </div>
      ) : null}
      <div className="mb-4">
        <input
          type="text"
          className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-fmb"
          placeholder="Search items..."
          value={searchQuery}
          onChange={handleSearch}
        />
      </div>
      <div className="space-y-2">
        {filteredItems.map((item, index) => (
          <div key={item._id}>
            <div className="flex items-center justify-between my-2">
              <div>
                <h2 className="text-sm font-semibold text-fmb">{item.name}</h2>
                <div className="text-xs text-gray-700">
                  <span className="mr-2">{item.category}</span>
                  <span>{item.unit}</span>
                </div>
              </div>
              {item.purchaseType && (
                <div className={`text-xs font-medium px-3 py-1 rounded-full ${getBadgeClass(item.purchaseType)}`}>
                  {item.purchaseType}
                </div>
              )}
            </div>
            {index < filteredItems.length - 1 && <hr className="my-1" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupplierListItems;